<template>
  <div class="detail-list" :class="saasId === 13 ? 'cash' : 'point'">
    <div class="tab-title" v-if="!isNoneCashVer">
      <p :class="{ on: saasId === 13 }" @click="changeTab(13)">
        现金明细<i class="cash"></i>
      </p>
      <p :class="{ on: saasId === 0 }" @click="changeTab(0)">
        积分明细<i class="point"></i>
      </p>
    </div>
    <div class="tab-card" :class="saasId === 13 ? 'cash' : 'point'">
      <div class="tab-head">
        <div class="left" v-if="saasId === 13">
          <p>
            <span class="txt">现金余额：</span>
            <span class="num">{{
              cashUserInfo.cashOutAmount
                ? parseFloat(cashUserInfo.cashOutAmount) / 100
                : 0
            }}</span
            ><span class="yuan">元</span>
          </p>
        </div>
        <div class="left" v-else>
          <p>
            <span>积分余额：</span>
            <span class="num">{{ cashUserInfo.creditsAmount || 0 }}</span>
          </p>
          <p class="year-clear" v-if="yearClearInfo.show === 1 && saasId === 0">
            <span v-if="yearClearInfo.credits > 0"
              >您有{{ yearClearInfo.credits }}积分将在{{
                yearClearInfo.deadline
              }}清零，请尽快使用</span
            >
            <span v-else>您{{ yearClearInfo.year }}年的积分已用完</span>
          </p>
        </div>
        <div class="right" :class="{ cash: saasId == 13 }"></div>
      </div>
      <div
        class="tab-content"
        :class="{ show: yearClearInfo.show && saasId === 0 }"
      >
        <div class="btns">
          <p :class="{ on: type === -1 }" @click="changeType(-1)">全部</p>
          <p :class="{ on: type === 1 }" @click="changeType(1)">收入</p>
          <p :class="{ on: type === 2 }" @click="changeType(2)">消耗</p>
        </div>
        <div
          class="tab-list"
          id="scrollBar"
          :class="{ nodata: !pageData.firstLoad && list.length === 0 }"
        >
          <LoadMore
            v-if="list.length"
            @load="getList"
            ref="wrapper"
            class="content-wrapper"
            :disabled="!pageData.hasNext"
            :lock="pageData.lock"
            scrollId="scrollBar"
          >
            <div class="line" v-for="(item, i) in list" :key="i">
              <div class="left">
                <p class="title">{{ item.name || item.remark }}</p>
                <p class="date">{{ item.time }}</p>
              </div>
              <div class="right">
                <div v-if="saasId === 13">
                  <span class="num">{{
                    item.credits > 0
                      ? `+${item.credits / 100}`
                      : item.credits / 100
                  }}</span
                  >元
                </div>
                <div v-else>
                  <span class="num">{{
                    item.credits > 0 ? `+${item.credits}` : item.credits
                  }}</span
                  >积分
                </div>
              </div>
            </div>
          </LoadMore>
          <div class="no-more" v-if="!pageData.hasNext && list.length > 0">
            暂时没有更多记录啦
          </div>

          <div
            class="no-data"
            v-if="!isLoading && !pageData.firstLoad && list.length === 0"
          >
            <p>暂未获得{{ saasId === 13 ? '现金' : '积分' }}</p>
            <p>快去做任务得{{ saasId === 13 ? '现金' : '积分' }}吧~</p>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-model" v-if="isLoading && list.length === 0">
      <div class="loading"></div>
    </div>
    <div class="footer-block">
      <div
        class="footer-btn"
        :class="{ disabled: cashUserInfo.cashOutAmount <= 0 }"
        v-if="saasId === 13"
        @click="clickJumpCash"
      >
        立即提现
      </div>
      <div class="footer-btn" v-if="saasId === 0" @click="clickJumpMall">
        立即兑换
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { loginMixin } from '@/utils/mixin'
import { getListByType, yearClear } from '@/request/cash'
import LoadMore from '@/v2-components/LoadMore'
import { jumpPage } from '@/utils/mUtil'

export default {
  mixins: [loginMixin],
  components: { LoadMore },
  data() {
    return {
      saasId: 13, // 13-现金 0-积分
      type: -1, // -1-全部 1-收入 2-消耗
      list: [],
      pageData: {
        lock: false,
        page: 1,
        pageSize: 10,
        hasNext: true,
        firstLoad: true,
      },
      yearClearInfo: {},
      isLoading: false,
    }
  },
  created() {
    const { saasId } = this.$route.query
    if (saasId) {
      this.saasId = parseInt(saasId)
    }
  },
  mounted() {
    MgtvApi.setWebviewTitle({
      title: '查看明细',
    })
    this.$nextTick(() => {
      this.getList()
      this.getYearClear()
      this.reportPv()
    })

    // 返回页面刷新
    MgtvApi.registerhandler('webviewBecomeActive', {}, () => {
      this.$store.dispatch('queryCashUserInfo')
    })
    if (!this.isLogin) {
      return this.clickLogin()
    }
  },
  methods: {
    async getYearClear() {
      const res = await yearClear()
      if (res.code === 200) {
        this.yearClearInfo = res.data
      }
    },
    changeTab(saasId) {
      if (saasId === this.saasId) {
        return
      }
      if (!this.isLogin) {
        return this.clickLogin()
      }
      this.saasId = saasId
      this.type = -1
      this.pageData.page = 1
      this.list = []
      this.getList()
      this.reportPv()
    },
    changeType(type) {
      if (type === this.type) {
        return
      }
      if (!this.isLogin) {
        return this.clickLogin()
      }
      this.type = type
      this.pageData.page = 1
      this.list = []
      this.getList()
    },
    async getList() {
      this.pageData.lock = true
      this.isLoading = true
      try {
        let { page, pageSize } = this.pageData
        const res = await getListByType({
          saasId: this.saasId,
          creditsType: this.type,
          page,
          pageSize,
        })
        if (res?.data?.length) {
          this.pageData.page += 1
          this.list.push(...(res.data || []))
        }
        this.pageData = {
          ...this.pageData,
          hasNext: res?.data?.length == this.pageData.pageSize,
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.pageData.lock = false
        this.pageData.firstLoad = false
        this.isLoading = false
      }
    },
    // 点击跳转积分商城
    clickJumpMall() {
      MgStat.send(
        'click',
        {},
        {
          cntp: 'score_queryDetail',
          mod: 'now_exchange',
          cont: '立即兑换',
        }
      )
      jumpPage('https://app.mgtv.com/credits/mall.html?lastp=cashList&isV2=1')
    },
    clickJumpCash() {
      if (!this.isLogin) {
        return this.clickLogin()
      }
      if (this.cashUserInfo.cashOutAmount <= 0) {
        this.$toast('提现金额不足，快去做任务吧！')
      } else {
        this.$router.push({ path: '/cash' })
      }
      MgStat.send(
        'click',
        {},
        {
          cntp: 'score_queryDetail',
          mod: 'score_queryDetail',
          cont: '立即提现',
        }
      )
    },
    reportPv() {
      MgStat.send(
        'pv',
        {
          tab: this.saasId === 13 ? 2 : 1,
        },
        {
          cntp: 'score_queryDetail',
        }
      )
    },
  },
  computed: {
    ...mapState(['isMGTV', 'userInfo', 'cashUserInfo', 'isNoneCashVer']),
    ...mapGetters(['isLogin']),
  },
}
</script>

<style lang="less" scoped>
.detail-list {
  // font-family: AlimamaFangYuanTiVF-Thin;
  background: #f5f5f5;
  padding: 36px;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .tab-title {
    display: flex;
    justify-content: space-around;
    width: 100%;
    padding: 0 110px;
    p {
      // font-family: AlimamaFangYuanTiVF-Thin;
      font-weight: 600;
      font-size: 28px;
      color: rgba(0, 0, 0, 0.3);
      text-align: center;
      padding-bottom: 20px;
      line-height: 32px;
      &.on {
        font-weight: 600;
        font-size: 32px;
        color: rgba(0, 0, 0, 0.8);
        position: relative;
        i {
          position: absolute;
          bottom: 0px;
          width: 24px;
          height: 6px;
          left: 50%;
          margin-left: -12px;
          border-radius: 11px;
          &.cash {
            background: #fdb03e;
          }
          &.point {
            background: #ff4500;
          }
        }
      }
    }
  }
  .tab-card {
    margin-top: 24px;
    position: relative;
    .tab-head {
      width: 678px;
      height: 184px;
      background: linear-gradient(45deg, #ff5b2c 10%, #ff9973 100%);
      border-radius: 36px 36px 0px 0px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 20px 36px;
      .left {
        display: flex;
        flex-direction: column;
        padding-top: 10px;
        p {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #ffffff;
          text-align: left;
          display: flex;
          align-items: center;
          .num {
            font-family: DIN Alternate, DIN Alternate;
            font-weight: bold;
            font-size: 64px;
            line-height: 64px;
            padding-right: 10px;
          }
          .yuan {
            font-family: PingFang SC-Semibold PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.6);
            padding-top: 3px;
          }
          .txt {
            padding-top: 3px;
          }
        }
        .year-clear {
          font-size: 22px;
          color: rgba(255, 255, 255, 0.6);
          line-height: 26px;
          padding-top: 12px;
        }
      }
      .right {
        .bgCover('../../../assets/v2/cash/p-logo.png');
        .wh(130px, 130px);
        position: absolute;
        top: 10px;
        right: 23px;
        z-index: 0;
        &.cash {
          width: 110px;
          height: 110px;
          top: 20px;
        }
      }
    }
    .tab-content {
      margin-top: -60px;
      width: 678px;
      background: #ffffff;
      border-radius: 36px;
      padding: 36px;
      z-index: 1;
      .btns {
        display: flex;
        padding-bottom: 36px;
        p {
          width: 138px;
          height: 60px;
          border-radius: 24px;
          font-weight: 500;
          font-size: 26px;
          line-height: 60px;
          text-align: center;
          margin-right: 24px;
          background: rgba(255, 69, 0, 0.1);
          color: #ff4500;
          &.on {
            background: linear-gradient(70deg, #ff5b2c 30%, #ff9973 100%);
            color: #ffffff;
          }
        }
      }
      .tab-list {
        height: calc(100vh - 470px);
        overflow-y: scroll;
        padding-bottom: 114px;
        .line {
          padding-bottom: 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            .title {
              font-weight: 400;
              font-size: 28px;
              color: rgba(0, 0, 0, 0.8);
            }
            .date {
              font-weight: 400;
              font-size: 22px;
              color: rgba(0, 0, 0, 0.4);
              padding-top: 6px;
            }
          }
          .right {
            font-weight: 400;
            font-size: 24px;
            color: rgba(0, 0, 0, 0.4);
            min-width: 61px;
            flex-shrink: 0;
            span {
              font-weight: bold;
              font-size: 40px;
              color: #ff4500;
              padding-right: 6px;
              font-family: DIN Alternate, DIN Alternate;
            }
          }
        }
        &.nodata {
          height: auto;
          padding-bottom: 0;
        }
      }
      .no-data {
        padding: 48px 0 24px 0;
        p {
          font-weight: 400;
          font-size: 24px;
          line-height: 40px;
          color: rgba(0, 0, 0, 0.2);
          text-align: center;
        }
      }
      &.show {
        margin-top: -36px;
      }
    }
  }
  .no-more {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    padding-bottom: 36px;
  }
  .footer-block {
    position: fixed;
    bottom: 58px;
    width: 678px;
    height: 216px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      #ffffff 70%,
      rgba(255, 255, 255, 1) 100%
    );
    border-radius: 0px 0px 36px 36px;
  }
  .footer-btn {
    .sizeColor(30px, #fff);
    .wh(534px, 102px);
    font-weight: bold;
    position: fixed;
    left: 50%;
    bottom: 104px;
    transform: translateX(-50%);
    display: block;
    line-height: 102px;
    text-align: center;
    background: linear-gradient(45deg, #ff5b2c 10%, #ff7e4f 100%);
    border-radius: 24px;
  }
  &.cash {
    .tab-card {
      .tab-head {
        background: linear-gradient(45deg, #fdb03e 0%, #ffd392 100%), #fdb03e;
        .right {
          .bgCover('../../../assets/v2/cash/c-logo.png');
        }
      }
      .tab-content {
        .btns {
          p {
            background: rgba(253, 176, 62, 0.1);
            color: #fdb03e;
            font-weight: bold;
            &.on {
              background: linear-gradient(45deg, #fdb03e 0%, #ffd392 100%);
              color: #ffffff;
            }
          }
        }
        .tab-list {
          .line {
            .right {
              span {
                color: #fdb03e;
              }
            }
          }
        }
      }
    }
    .footer-btn {
      background: linear-gradient(45deg, #fdb03e 0%, #ffc369 100%);
      &.disabled {
        background: #eeeeee;
        color: rgba(0, 0, 0, 0.1);
      }
    }
  }
  .loading-model {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.7);
    align-items: center;
    z-index: 99;
    .loading {
      width: 40px;
      height: 40px;
      border: 4px solid #ff5b2c;
      border-top-color: transparent;
      border-radius: 100%;
      animation: circle infinite 1s linear;
    }
  }

  @keyframes circle {
    0% {
      transform: translateY(-50%) rotate(0deg);
    }

    100% {
      transform: translateY(-50%) rotate(360deg);
    }
  }
}
::-webkit-scrollbar {
  display: none;
}
</style>
